export default __webpack_public_path__ + "static/media/cycles2.efe49803.png";